import * as signalR from "@microsoft/signalr";
import { WaiterHubUrl } from "../../../consts/api";
import { useSelector } from "react-redux";
import { getCompanyId } from "../../../react-reduxs/slices/auth/auth_slice";
import { WaiterModel } from "../../../models/waiter.model";

interface ConfirmWaiterCallButtonProps {
  tableId: string;
  waiterModel: WaiterModel | undefined;
}

export const ConfirmWaiterCallButton = ({
  tableId,
  waiterModel,
}: ConfirmWaiterCallButtonProps) => {
  const companyId = useSelector(getCompanyId);
  return (
    <div>
      <button
        style={{
          background: "#7C3AED",
          color: "#fff",
          fontWeight: 800,
          fontSize: 13,
          padding: "12px 0",
          borderRadius: 12,
          width: "100%",
          border: "none",
          cursor: "pointer",
        }}
        disabled={waiterModel === undefined}
        onClick={async () => {
          const connection = new signalR.HubConnectionBuilder()
            .withUrl(WaiterHubUrl(companyId).url)
            .withAutomaticReconnect()
            .configureLogging(signalR.LogLevel.Information)
            .build();

          try {
            await connection
              .start()
              .then(() => {
                console.log("SignalR bağlantısı kuruldu.WaiterHub");
              })
              .catch((error) => {
                console.error(
                  "SignalR bağlantısı başlatılırken hata oluştu:",
                  error,
                );
              });
            console.error(companyId, tableId);

            if (companyId != "") {
              await connection.invoke("WaiterEndCall", companyId, tableId);
            }
          } catch (error) {
            console.error(
              "SignalR bağlantısı başlatılırken hata oluştu:",
              error,
            );
          } finally {
            connection.stop();
          }
        }}
      >
        Garson Çağır Onayla 📞
      </button>
    </div>
  );
};
